export function AppTitle() {
  return <h1>Tic Tac Toe</h1>;
}
